module.exports = __webpack_public_path__ + "img/O@2x.eb409c81.jpg";